import initialState from './initialState';
import {
  TABLE_EDITOR_GET_DIMENSIONS_LIST_INIT,
  TABLE_EDITOR_GET_DIMENSIONS_LIST_SUCCESS,
  TABLE_EDITOR_GET_DIMENSIONS_LIST_FAILURE,
  TABLE_EDITOR_GET_DIMENSION_INSTANCES_LIST_INIT,
  TABLE_EDITOR_GET_DIMENSION_INSTANCES_LIST_SUCCESS,
  TABLE_EDITOR_GET_DIMENSION_INSTANCES_LIST_FAILURE,
  TABLE_EDITOR_SET_FORMULA_TO_EDIT_OBJECT,
  TABLE_EDITOR_EDIT_FORMULA_TO_EDIT_OBJECT,
  TABLE_EDITOR_FORMULA_VALIDATION_INIT,
  TABLE_EDITOR_FORMULA_VALIDATION_SUCCESS,
  TABLE_EDITOR_FORMULA_VALIDATION_FAILURE,
  TABLE_EDITOR_RESET
} from '../../actions/tableEditor/types';
import ReducersTooling from '../../../tooling/reducersTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormulaUtilsTooling from '../../../tooling/formulaUtilsTooling';

export default function tableEditor(state = initialState, action) {
  switch (action.type) {      
    case TABLE_EDITOR_GET_DIMENSIONS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "dimensionsList");
    case TABLE_EDITOR_GET_DIMENSIONS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "dimensionsList");
    case TABLE_EDITOR_GET_DIMENSIONS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "dimensionsList");
    case TABLE_EDITOR_GET_DIMENSION_INSTANCES_LIST_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "dimensionInstancesList");
    case TABLE_EDITOR_GET_DIMENSION_INSTANCES_LIST_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "dimensionInstancesList");
    case TABLE_EDITOR_GET_DIMENSION_INSTANCES_LIST_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "dimensionInstancesList");
    case TABLE_EDITOR_SET_FORMULA_TO_EDIT_OBJECT:
      return {
        ...state,
        formulaToEditObject: action.formulaObject,
        formulaValidation: initialState.formulaValidation
      }
    case TABLE_EDITOR_EDIT_FORMULA_TO_EDIT_OBJECT:
      return {
        ...state,
        formulaToEditObject: FormulaUtilsTooling.editFormulaObject(state.formulaToEditObject, action.parentId, action.index, action.position, action.valueToAdd)
      }
    case TABLE_EDITOR_FORMULA_VALIDATION_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "formulaValidation");
    case TABLE_EDITOR_FORMULA_VALIDATION_SUCCESS:
      let newState = ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "formulaValidation");
      if(action.payload.status == 422 && action.payload.data && action.payload.data.formulaArray) {
        newState.formulaToEditObject = action.payload.data;
      }
      return newState
    case TABLE_EDITOR_FORMULA_VALIDATION_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "formulaValidation");
    case TABLE_EDITOR_RESET:
      return initialState;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/tableEditor/index.js